import { render, staticRenderFns } from "./RegisterAccess.vue?vue&type=template&id=3fda0d59&scoped=true"
import script from "./RegisterAccess.vue?vue&type=script&lang=js"
export * from "./RegisterAccess.vue?vue&type=script&lang=js"
import style0 from "./RegisterAccess.vue?vue&type=style&index=0&id=3fda0d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda0d59",
  null
  
)

export default component.exports